import { CopyButton, SkeletonPlaceholder } from "@expert/common-ui";
import type { SkeletonProps } from "@mantine/core";
import { Text } from "@mantine/core";
import type { JSX } from "react";
import type { ChatTask } from "@/sdk";

const normalizePhoneNumber = (mdn: string) => mdn.replace(/\D/g, "");

interface CustomerMdn extends Pick<ChatTask, "mdn">, SkeletonProps {
    showCopyMdnIcon: boolean;
}

export const CustomerMdn = ({ mdn, showCopyMdnIcon, ...skeletonProps }: CustomerMdn): JSX.Element => {
    return (
        <SkeletonPlaceholder visible={mdn.loading} {...skeletonProps}>
            <Text span className="fs-mask" size="sm" style={{ whiteSpace: "nowrap" }} truncate={false}>
                {mdn.error ? "Number unavailable" : mdn.value}
            </Text>
            {showCopyMdnIcon && mdn.value && (
                <CopyButton
                    value={normalizePhoneNumber(mdn.value)}
                    showTooltip={{ copiedLabel: "Copied", copyLabel: "Copy number" }}
                    checkMarkOverride={{ fill: "var(--mantine-color-dark-2)" }}
                    copyIconOverride={{ stroke: "var(--mantine-color-dark-2)" }}
                />
            )}
        </SkeletonPlaceholder>
    );
};
